// src/api.js
import axios from 'axios';
import { supabase } from './supabaseClient';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

// This is an "interceptor". It's a function that runs BEFORE any API request is sent.
apiClient.interceptors.request.use(
  async (config) => {
    // We get the current user's session from Supabase.
    const { data: { session } } = await supabase.auth.getSession();
    
    // If the user is logged in, we get their access token...
    if (session?.access_token) {
      // ...and add it to the 'Authorization' header.
      config.headers['Authorization'] = `Bearer ${session.access_token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default apiClient;